import React, { Fragment, lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import {
  HashRouter as Router,
  BrowserRouter,
  Route,
  Switch,
  hashHistory
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { createGlobalStyle } from 'styled-components';
import { PersistGate } from 'redux-persist/integration/react';

// CSS
import './assets/css/structure.scss';
import './assets/css/styles.css';
import './assets/css/custom.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import './assets/css/gamification.css';
// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/js/bootstrap.js';

import store, { persistedStore } from './store';
import reset from './constants/css/reset';
import Loader from './components/Common/loader';

import MainApp from './components/main-app';
// const LazyMainApp = lazy(() => import('./components/main-app'));

const GlobalStyle = createGlobalStyle`${reset}`;

ReactDOM.render(
  <Router>
    <Fragment>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistedStore}>
          <MainApp />
        </PersistGate>
      </Provider>
    </Fragment>
  </Router>,
  document.getElementById('root')
);
